module.exports = __webpack_public_path__ + "static/media/Colorado_Avalanche.082fec15.svg";